import { defineComponent as _defineComponent } from 'vue'
import { resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { computed } from 'vue'
    import { useRoute } from 'vue-router'
    import PortfolioNavigation from './PortfolioNavigation.vue'
    import DecisionNavigation from './DecisionNavigation.vue'

    // ---------------- props ----------------

    
export default /*@__PURE__*/_defineComponent({
  __name: 'PortfolioOrDecisionNavigation',
  props: {
    workspaceId: {},
    projectId: {}
  },
  setup(__props: any) {

    const props = __props

    // ---------------- routing ----------------

    const route = useRoute()

    // ---------------- derived ----------------

    // Detect type from URL path (hash or history mode safe)
    const solutionType = computed(() =>
    {
        const path = route.path.toLowerCase()

        if (path.startsWith('/portfolio'))
            return 'portfolio'

        if (path.startsWith('/decision'))
            return 'decision'

        return 'portfolio'
    })

    const navComponent = computed(() =>
        solutionType.value === 'portfolio'
            ? PortfolioNavigation
            : DecisionNavigation
    )

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_resolveDynamicComponent(navComponent.value), {
    workspaceId: __props.workspaceId,
    projectId: __props.projectId
  }, null, 8 /* PROPS */, ["workspaceId", "projectId"]))
}
}

})